import {Badge} from './src';

export default Badge;



/** WEBPACK FOOTER **
 ** ./client/shared/packages/Badge/index.js
 **/